/* THIS IS A BIT-AUTO-GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

Object.defineProperty(exports, "__esModule", { value: true });
module.exports = require('@bit/fabfitfun.shared.utils.arg-types');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.shared.global.button/dist/utils/argTypes.js
// module id = 482
// module chunks = 0